var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #969495;\n      }\n\n      .st1 {\n        fill: #1c1819;\n      }\n\n      .st2 {\n        fill: #242021;\n      }\n\n      .st3 {\n        fill: #120f10;\n      }\n\n      .st4 {\n        fill: #312f30;\n      }\n\n      .st5 {\n        fill: #3a3738;\n      }\n\n      .st6 {\n        fill: #fbfbfb;\n      }\n\n      .st7 {\n        fill: #3b3839;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M.6,14.4h22.9v8.6H.6v-8.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M15.8,15.3h7.6v7.6h-14.3v-1h6.7v-6.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M.6,15.3h8.6c0,2.2,0,5.4,0,7.6h-4.9c-1.2,0-2.4,0-3.7,0v-7.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.8,1h6.7v8.6h-6.7V1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M.6,1h6.7v8.6H.6V1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.1,1h3.8q-.5,3.8,2.9,7.2H7.2c3.3-2.9,3.3-3.3,2.9-7.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.7,2.9h3.8v5.7h-4.8c.3-1.9.6-3.8,1-5.7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M9.6,17.2h5.7v3.8h-5.7v-3.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M.6,15.3h7.6q-1.1,1.5-2.9,2.9-2.6-.3-4.8-1v-1.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.919427cb6313d6345bd3091e78787f9c.svg";
export { ForwardRef as ReactComponent };